import { createCustomEnum } from "../customEnum";

const RefundPolicyTypes = createCustomEnum({
	RefundWithin30Days: {
		value: 0,
		name: "RefundWithin30Days",
		displayName: "Refund Within 30 Days",
	},
	ExchangeOnly: {
		value: 1,
		name: "ExchangeOnly",
		displayName: "Exchange Only",
	},
	Other: {
		value: 2,
		name: "Other",
		displayName: "Other",
	},
	None: {
		value: 3,
		name: "None",
		displayName: "None",
	},
});

export default RefundPolicyTypes;
